import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { H3, H4 } from '../../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconPortfolioOrders } from '../../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from '../Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import { formatUSD } from '../../../helpers/helperFunctions';
import { MARKETPLACE, POWERPACKS } from '../../../routes/routes';
import Spinner from '../../../components/common/Spinner';

import { PortfolioPowerPacksItem } from './PortfolioPowerPacksItem';
import { PackageTrading, UserPackage } from '../Portfolio.types';

export const PowerPacksSummary = () => {
  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const [packageItem, setPackageItem] = useState<
    UserPackage | PackageTrading | null
  >(null);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { powerPackPackages, loadingSummary } = useAppSelector(
    (state) => state.portfolio
  );

  return (
    <div style={{ marginBottom: 40 }}>
      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Dr Odin NFT</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {powerPackPackages?.orders?.orders?.map((item: any, i: number) => (
            <PortfolioPowerPacksItem key={i} item={item} />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
